import { isEqual } from 'es-toolkit';

// Ensures that the given `elementToPush` exists in the array (using guid-based checks).  If necessary, the element will
//   be added to the array or the existing occurrence will be updated.
export default <T extends { guid: string }>(array: ReadonlyArray<T>, elementToPush: T) => {
  if (array.some((element) => element.guid === elementToPush.guid)) {
    return array.map((element) => {
      if (element.guid === elementToPush.guid && !isEqual(element, elementToPush)) {
        return elementToPush;
      }

      return element;
    });
  }

  return array.concat([elementToPush]);
};
